import { Box, Container } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ListMain from "./sams/cimplist/ListMain";
import ButtonAppBar from "./ButtonAppBar";
import DashBoard from "./sams/DashBoard/DashBoard";
import InoutMain from "./sams/Cargo/InoutMain";
import Test from "./Test";
import HoldList from "./sams/SQ/HoldList";
import DPRLIST from "./sams/Dpr/DPRLIST";
import EdiMonitorList from "./sams/It/EdiMonitorList";
import { Alert, Button, IconButton } from "@mui/joy";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import CircularProgress from "@mui/joy/CircularProgress";
import LinearProgress from "@mui/joy/LinearProgress";
import Typography from "@mui/joy/Typography";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";
import SphList from "./sams/cimplist/SphList";
export default function MainPage() {
  const [openErr, setOpenErr] = useState(0);
  const [openText, setOpenText] = useState(0);
  const [openErrText, setOpenErrText] = useState(0);
  const [openSuc, setOpenSuc] = useState(0);
  const [data, setData] = useState();
  const [props2, setProps2] = useState([]);
  const location = useLocation();
  const containersx = {
    mt: 9,
    ml: 9,
  };

  const props = (item) => {
    if (item.openErr === 1) {
      setOpenErr(1);
      setOpenText(1);
      setData(item.detail);
    } else if (item.openErr === 2) {
      setOpenErr(1);
      setOpenText(0);
      setData(item.detail);
    } else if (item.openErr === 0) {
      setOpenErr(0);
    }
    if (item.openSuc === 1) {
      setOpenSuc(item.openSuc);
      setOpenErr(0);
    } else if (item.openSuc === 0) {
      setOpenSuc(item.openSuc);
    }
  };
  const closeBtn = () => {
    props({ openErr: 0 });
    setProps2({
      btn: "Y",
    });
  };

  const openBtn = () => {
    setProps2({
      btn: "N",
    });
  };

  const closeSucBtn = () => {
    props({ openSuc: 0 });
  };

  return (
    <Box>
      <ButtonAppBar />

      <Box sx={{ ...containersx, width: "95%", height: 750 }}>
        {location.pathname === "/sams/cimplist" && <ListMain />}
        {location.pathname === "/sams/dashboard" && <DashBoard />}
        {location.pathname === "/sams/inoutlive" && <InoutMain />}
        {location.pathname === "/sams/inoutinlive" && <InoutMain />}
        {location.pathname === "/sq/holdlist" && <HoldList />}
        {location.pathname === "/edi/livelist" && (
          <EdiMonitorList props={props} props2={props2} />
        )}
        {location.pathname === "/sams/sphList" && <SphList />}

        {/* {location.pathname === "/dpr/dprlist" && <DPRLIST />} */}
      </Box>
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: "auto",
          right: 0,
          padding: "16px",
          width: "30%",
          display: openErr === 1 ? "block" : "none",
        }}
      >
        <Alert
          startDecorator={<WarningIcon />}
          variant="solid"
          color="danger"
          endDecorator={
            <React.Fragment>
              <Button
                onClick={(e) => (e.stopPropagation(), openBtn())}
                variant="solid"
                color="danger"
                sx={{ mr: 1, display: openText === 1 ? "block" : "none" }}
              >
                YES
              </Button>
              <IconButton
                onClick={(e) => (e.stopPropagation(), closeBtn())}
                variant="solid"
                size="sm"
                color="danger"
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          }
        >
          {data}
        </Alert>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: "auto",
          right: 0,
          padding: "16px",
          width: "30%",
          opacity: 1,
          display: openSuc === 1 ? "block" : "none",
        }}
      >
        <Alert
          size="lg"
          color="success"
          variant="solid"
          invertedColors
          startDecorator={
            <AspectRatio
              variant="solid"
              ratio="1"
              sx={{
                minWidth: 40,
                borderRadius: "50%",
                boxShadow: "0 2px 12px 0 rgb(0 0 0/0.2)",
              }}
            >
              <div>
                <Check fontSize="xl2" />
              </div>
            </AspectRatio>
          }
          endDecorator={
            <IconButton
              variant="plain"
              sx={{
                "--IconButton-size": "32px",
                transform: "translate(0.5rem, -0.5rem)",
              }}
              onClick={(e) => (e.stopPropagation(), closeSucBtn())}
            >
              <Close />
            </IconButton>
          }
          sx={{ alignItems: "flex-start", overflow: "hidden" }}
        >
          <div>
            <Typography level="title-lg">Success</Typography>
            <Typography level="body-sm">
              Success is walking from failure to failure with no loss of
              enthusiam.
            </Typography>
          </div>
          <LinearProgress
            variant="solid"
            color="success"
            value={40}
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              borderRadius: 0,
            }}
          />
        </Alert>
      </div>
    </Box>
  );
}
